/**
 * EmptyCanvasState — calm "we're listening" state shown before any nodes
 * land on the canvas. Matches the v1.1 brand pillar (Quietly warm) — no card,
 * no border, just the Kaiva avatar pulsing over a 3 px sienna sweep.
 */

import { KaivaAvatar } from '@/components/brand';

export function EmptyCanvasState() {
  return (
    <div className="flex w-[360px] max-w-full flex-col items-center text-center">
      <KaivaAvatar size={32} pulse />
      <h2
        className="mt-4 font-semibold"
        style={{
          fontFamily: 'var(--font-sans)',
          fontWeight: 600,
          fontSize: 17,
          color: 'hsl(var(--foreground))',
          letterSpacing: '-0.01em',
        }}
      >
        We're listening
      </h2>
      <p
        className="mt-2"
        style={{
          fontFamily: 'var(--font-sans)',
          fontWeight: 400,
          fontSize: 13,
          color: 'hsl(var(--muted-foreground))',
          lineHeight: 1.5,
        }}
      >
        Tell Kaiva what happens first. Knowledge will start landing here as you talk.
      </p>
      <div
        aria-hidden="true"
        className="mt-5 h-[3px] w-[200px] overflow-hidden rounded-full"
        style={{ background: 'hsl(var(--muted))' }}
      >
        <div
          className="kaiva-listening-track h-full w-8 rounded-full"
          style={{ background: 'hsl(var(--sienna))' }}
        />
      </div>
    </div>
  );
}
